import React, { PureComponent } from 'react'

import { YesNoPanel } from 'app/Components/Survey/Panel'
import Question2 from './Question2'

export default class Question1 extends PureComponent {


  render() {
    const question = 'Are you a medical or non-medical organization or business?'
    const title = 'question1'
    const choices = ['Medical', 'Non-Medical']
    return (
      <YesNoPanel {...this.props} title={title} question={question} nextQuestion={Question2} choices={choices} buttonText='Next' />
    )
  }
}



/** WEBPACK FOOTER **
 ** ./survey/questions/Question1.js
 **/